import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HedaCoreUtilModule } from '@heda/core-util';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TerminologyLibModule } from 'app/mdm/terminology-lib/terminology-lib.module';
import { MeasurementUnitService } from 'app/mdm/terminology/measurment-unit/services/measurement-unit.service';
import { MeasurementUnitEditComponent } from 'app/mdm/terminology/measurment-unit/containers/measurement-unit-edit.component';
import { MeasurementUnitListComponent } from 'app/mdm/terminology/measurment-unit/containers/measurement-unit-list.component';
import { HedaCoreHospitalUiModule } from '@heda/core-hospital-ui';

export const MU_ROUTES: Routes = [
  { path: '', component: MeasurementUnitListComponent },
  { path: 'add', component: MeasurementUnitEditComponent },
  { path: 'edit/:measurementUnitId', component: MeasurementUnitEditComponent },
];

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    HedaCoreHospitalUiModule,
    HedaCoreUtilModule,
    FormsModule,
    TerminologyLibModule,
    ReactiveFormsModule,
  ],
  declarations: [MeasurementUnitListComponent, MeasurementUnitEditComponent],
  providers: [MeasurementUnitService],
})
export class MeasurementUnitModule {}
